import LastFewDays from "./LastFewDays";

export default LastFewDays;
